module.exports = __webpack_public_path__ + "img/202105.37858784.png";